export function renderName(displayName?: string, informalName?: string) {
  if (!displayName) return "";
  const [firstName, ...lastNameAndSuffix] = displayName.split(" ");
  const title =
    informalName && informalName !== firstName ? `${firstName} (${informalName}) ${lastNameAndSuffix.join(" ")}` : displayName;
  return title;
}
